import Image from "next/image";

interface EOChatLogoProps {
    width?: number;
    height?: number;
    className?: string;
}

export function EOChatLogo({ width, height, className }: EOChatLogoProps) {
    return (
        <Image
            src="/eo-chat-logo.png"
            alt="EO Chat Logo"
            width={width}
            height={height}
            className={className}
        />
    );
}